import { render, staticRenderFns } from "./section-box.vue?vue&type=template&id=4e319e78&scoped=true"
import script from "./section-box.vue?vue&type=script&lang=js"
export * from "./section-box.vue?vue&type=script&lang=js"
import style0 from "./section-box.vue?vue&type=style&index=0&id=4e319e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e319e78",
  null
  
)

export default component.exports